import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import './CourseTable.css'; // Optional: For custom styles if needed
import plus_icon from "../../../assets/dashboard/plus-icon.svg"
import { getAllCourses } from '../../../services/Trainer/trainer';
import moment from 'moment';
// import ProgressDashes from './ProgressDashes';
import './profileTable.css'
import { toast } from 'react-toastify';
import { PieChart, Pie, Cell, BarChart, Bar, XAxis } from 'recharts';

const CourseTable = ({ courses, onDeclinePolicy, onAssignStaff, onAccept }) => {
    const navigate = useNavigate()

    const onEdit = (id, isVerified) => {
        if (isVerified) {
            toast.error("You cannot make changes to this course because it has been verified.")
        }
        else {
            navigate(`/manager/courses/edit-course/${id}`);

        }
    }

    return (
        <div className="management-container">


            <div className="table-container">
                <table className="course-table">
                    <thead>
                        <tr>
                            <th colSpan="5">
                                <div className="staff-profile-courses-table-header table-header">
                                    <div className="cell">Sr #</div>
                                    <div className="cell">Course Name</div>
                                    <div className="cell">Course Status</div>
                                    <div className="cell">Completion%</div>
                                    <div className="cell">Score%</div>

                                    <div className="cell">View Certificate</div>
                                    {/* <div className="cell">Action</div> */}
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                           courses && courses?.length > 0 ? 
                            <>
                             {courses && courses.map((course, index) => {

                            const status =  (course.course?.completionPercentage == "0" ? "Start" : course.course?.isCompleted ? "Completed" : "In Progress");
                            const completion = course.course?.completionPercentage ?? 0;
                            const score = course.course.score ?? 0;

                            const getStatusColor = (status) => {
                                switch (status.toLowerCase()) {
                                    case "completed":
                                        return "#d0f8ee";
                                    case "in progress":
                                        return "#fde7aa";
                                    case "re-take":
                                        return "#ffdbdb";
                                    default:
                                        return "#f0f0f0";
                                }
                            };

                            const getScoreColor = (score) => {
                                if (score == 100) return "#8AB5A0";       // Exactly 100
                                if (score > 70) return "#FFBF00";          // Greater than 70
                                if (score > 0) return "#FF2300"; // Less than 50 but greater than 0
                                if (score == 0) return "#EDEDED";         // Exactly 0
                                return "#EDEDED"; // Fallback (optional)
                            };

                            const scoreColor = getScoreColor(score);

                            return (
                                <tr key={course._id}>
                                    <td colSpan="5">
                                        <div className="staff-profile-courses-table-row table-row">
                                            <div className="cell">{index + 1}</div>
                                            <div className="cell">{course.course.title}</div>
                                            {/* <div className="cell viewed">{course.status}</div>
                                        <div className="cell viewed">{course.completion}</div>
                                        <div className="cell viewed">{course.score}</div> */}
                                            <div className="cell">
                                                {
                                                    status == "In Progress" ?
                                                    <span
                                                    className="px-2 py-1 rounded-pill text-capitalize"
                                                    style={{ backgroundColor: getStatusColor(status), fontSize: 12,cursor:'pointer' }}
                                                    onClick={()=> navigate(`/staff/courses/${course?.course?._id}`)}
                                                >
                                                    {status}
                                                </span>
                                                :

                                                <span
                                                    className="px-2 py-1 rounded-pill text-capitalize"
                                                    style={{ backgroundColor: getStatusColor(status), fontSize: 12 }}
                                                >
                                                    {status}
                                                </span>

                                                }
                                                
                                            </div>

                                            <div className="cell" style={{ display: 'flex', position: 'relative', width: 40, height: 40 }}>
                                                <PieChart width={40} height={40}>
                                                    <Pie
                                                        data={[
                                                            { name: 'done', value: completion },
                                                            { name: 'left', value: 100 - completion }
                                                        ]}
                                                        cx="50%"
                                                        cy="50%"
                                                        innerRadius={12}
                                                        outerRadius={20}
                                                        startAngle={90}
                                                        endAngle={-270}
                                                        paddingAngle={0}
                                                        dataKey="value"
                                                    >
                                                        <Cell fill="#54C29F" />
                                                        <Cell fill="#e0e0e0" />
                                                    </Pie>
                                                </PieChart>
                                                <div
                                                    className="text-center small"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        fontSize: '10px', // optional for better scaling
                                                        pointerEvents: 'none' // optional: let clicks go through
                                                    }}
                                                >
                                                    {completion}
                                                </div>
                                            </div>
                                            {
                                                console.log("scorescorescore", score)
                                            }
                                            {/* <div className="cell" style={{ display: 'flex' }}>
                                                <BarChart width={100} height={20} data={[
                                                    { name: 'Score', value: score },
                                                    { name: 'Max', value: 100 } // invisible reference
                                                ]}>
                                                    <XAxis dataKey="name" hide />
                                                    <Bar dataKey="value" fill={scoreColor} radius={[10, 10, 10, 10]} />
                                                </BarChart>
                                                <div className="small text-end">{score}%</div>
                                            </div> */}
                                            <div className="cell" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <div style={{
                                                    width: 80,
                                                    height: 10,
                                                    backgroundColor: '#EDEDED', // base background
                                                    borderRadius: 10,
                                                    position: 'relative',
                                                    overflow: 'hidden'
                                                }}>
                                                    {score > 0 && (
                                                        <div style={{
                                                            width: `${score}%`,
                                                            height: '100%',
                                                            backgroundColor: getScoreColor(score),
                                                            borderRadius: 10,
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0
                                                        }} />
                                                    )}
                                                </div>
                                                <div className="small text-end">{score}%</div>
                                            </div>
                                            <div className="cell viewed">

                                                <button
                                                    className="delete-btn d-flex justify-content-between align-items-center w-100"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        // if(course?.course?.isCompleted){
                                                        // navigate(`/staff/certificate/${course?.course?._id}`)

                                                        // }else{
                                                        //     toast.error("Course is not Completed")
                                                        // }
                                                        if (!course?.course?.isCompleted) {
                                                        toast.error("Course is not Completed");
                                                        } else if (course?.course?.score < 80) {
                                                        toast.error("Certificate only viewable for score 80+");
                                                        } else {
                                                        navigate(`/staff/certificate/${course?.course?._id}`);
                                                        }
                                                        // onDeclinePolicy(course._id);
                                                    }}
                                                >
                                                    <i className="bi bi-eye" style={{color:'black'}}></i>
                                                    {/* <span className="icon-circle bg-danger-subtle text-danger ms-2">
                                                        <i className="bi bi-trash-fill"></i>
                                                    </span> */}
                                                </button>
                                            </div>




                                            {/* <div className="cell viewed"><ProgressDashes current={5} total={5} /></div> */}


                                            {/* <div className="cell">{moment(course?.createdAt).format("DD-MM-YYYY")}</div>
                                        <div className="cell viewed">{course.isVerified ? "YES" :"NO"}</div> */}

                                            {/* <div className="cell action">
                                            <button className="action-button" data-bs-toggle="dropdown">
                                                <i className="bi bi-three-dots"></i>
                                            </button>
                                            <div className="dropdown-menu">
                                                
                                                <button
                                                    className="delete-btn d-flex justify-content-between align-items-center w-100"
                                                    onClick={(e) => {
                                                        // e.stopPropagation();
                                                        // onAccept(course._id);
                                    

                                                          e.stopPropagation();
                                                        onEdit(course._id,course?.isVerified);
                                                    }}
                                                >
                                                    <span className="text-secondary">Edit</span>
                                                    <span className="icon-circle bg-success-subtle text-secondary ms-2">
                                                        <i className="bi bi-pencil-fill"></i>
                                                    </span>
                                                </button>

                                                <button
                                                    className="delete-btn d-flex justify-content-between align-items-center w-100"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onDeclinePolicy(course._id);
                                                    }}
                                                >
                                                    <span className="text-danger">Delete</span>
                                                    <span className="icon-circle bg-danger-subtle text-danger ms-2">
                                                        <i className="bi bi-trash-fill"></i>
                                                    </span>
                                                </button>

                                                <hr className="my-2" />

                                               

                                            </div>
                                        </div> */}
                                        </div>
                                    </td>
                                </tr>
                            )
                        }
                        )}
                            </>
                            :
                        <div
                        className="col-md-12"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '200px', // Adjust as needed
                            gap: '8px',
                            fontSize: '18px',
                            color: '#666'
                        }}
                        >
                        <i className="bi bi-info-circle" style={{ fontSize: '20px' }}></i>
                        No records found
                        </div>
                        }
                       
                    </tbody>
                </table>
            </div>
        </div>

    );
};

export default CourseTable;
